import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import commonStyles from 'styles/common.pcss';
import { SmartForm, SmartInput, Button, Preloader } from 'components';

import BISCaptcha from '../BISCaptcha';
import BeautyCtn from '../BeautyCtn';
import styles from './styles.pcss';

const cx = classNames.bind({ ...commonStyles, ...styles });

export default class SMSCaptchaForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      captchaKey: '',
    };
  }

  onCaptchaChange = ({ captchaKey }) => this.setState({ captchaKey });

  render() {
    const {
      isLight,
      isCompact,
      isPending,
      ctn,
      bisUrl,
      description,
      buttonText,
      onSubmit,
      onReset,
    } = this.props;

    return (
      <SmartForm className={cx('form', { compact: isCompact, light: isLight })} onSubmit={onSubmit}>
        <BeautyCtn ctn={ctn} onReset={onReset} className={cx('marb-xs')} />
        <div className={cx('description', 'sms')}>{description}</div>
        <SmartInput
          type="hidden"
          name="captchaKey"
          inputId="captchaKey"
          value={this.state.captchaKey}
          className={cx('inputField')}
        />
        <BISCaptcha
          className={cx('captcha')}
          host={bisUrl}
          placeholder="Введите капчу"
          inputId="captcha"
          onChange={this.onCaptchaChange}
        />
        {isPending ?
          <Preloader />
        : <Button className={cx('button')}>{buttonText}</Button>}
      </SmartForm>
    );
  }
}

SMSCaptchaForm.propTypes = {
  isLight: PropTypes.bool,
  isCompact: PropTypes.bool,
  isPending: PropTypes.bool,
  ctn: PropTypes.string,
  bisUrl: PropTypes.string,
  buttonText: PropTypes.string,
  description: PropTypes.string,
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
};

SMSCaptchaForm.defaultProps = {
  bisUrl: 'https://identity.beeline.ru',
};
